import { makeRequest, buildOptions } from './ServiceHelpers';

const endpointUrl = 'https://priceintegration.financialflows.cimpress.io';

export const getRequiredInputs = sku => {
  const options = buildOptions({ method: 'GET' });

  return makeRequest(endpointUrl, `/v1/requiredInputs/${sku}`, options, 'getting required inputs');
};
